import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
import { motion } from "motion/react";

const faqs = [
  {
    question: "O que é o MEYJE UI?",
    answer:
      "O MEYJE UI é um editor visual de temas para componentes shadcn/ui com suporte ao Tailwind CSS. Ele vem com um conjunto de temas pré-construídos que você pode usar para personalizar seu projeto.",
  },
  {
    question: "O MEYJE UI é gratuito?",
    answer:
      "Sim, o MEYJE UI é gratuito. Temos funcionalidades premium com IA, mas a funcionalidade principal é gratuita.",
  },
  {
    question: "O que é o MEYJE UI Pro e o que ele inclui?",
    answer:
      "O MEYJE UI Pro é um serviço de assinatura premium disponível por R$19,99 por mês. Ele desbloqueia todas as funcionalidades avançadas, incluindo a poderosa geração de temas com IA. Você pode cancelar sua assinatura a qualquer momento.",
  },
  {
    question: "Como personalizo um tema shadcn/ui?",
    answer:
      "Você pode personalizar um tema selecionando um preset no menu e ajustando as cores como preferir. Quando estiver satisfeito, pode exportar o código copiando-o ou executando o comando para aplicá-lo automaticamente ao seu projeto.",
  },
  {
    question: "O MEYJE UI suporta Tailwind CSS v4?",
    answer:
      "Sim, o MEYJE UI suporta Tailwind CSS v4 (e v3). Você pode escolher a versão do Tailwind que deseja usar no menu da seção de Código.",
  },
  {
    question: "Preciso saber Tailwind CSS para usar o MEYJE UI?",
    answer:
      "Não, você não precisa saber Tailwind CSS. Nosso editor visual facilita a personalização sem escrever código. No entanto, algum conhecimento ajudará a entender melhor o código gerado.",
  },
  {
    question: "Posso usar o MEYJE UI em um projeto shadcn/ui já existente?",
    answer:
      "Sim, o MEYJE UI foi projetado para funcionar com projetos shadcn/ui existentes. Basta exportar o código gerado e aplicá-lo ao seu projeto.",
  },
];

export function FAQ() {
  return (
    <section id="faq" className="w-full py-20 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-12 flex flex-col items-center justify-center space-y-4 text-center"
        >
          <Badge
            className="rounded-full px-4 py-1.5 text-sm font-medium shadow-sm"
            variant="secondary"
          >
            <span className="text-primary mr-1">✦</span> FAQ
          </Badge>
          <h2 className="from-foreground to-foreground/80 bg-gradient-to-r bg-clip-text text-3xl font-bold tracking-tight text-transparent md:text-4xl">
            Perguntas Frequentes
          </h2>
          <p className="text-muted-foreground max-w-[800px] md:text-lg">
            Encontre respostas para as dúvidas mais comuns sobre o MEYJE UI.
          </p>
        </motion.div>

        <div className="mx-auto max-w-3xl">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.3, delay: i * 0.05 }}
              >
                <AccordionItem value={`item-${i}`} className="border-border/40 group border-b py-2">
                  <AccordionTrigger className="group-hover:text-primary text-left font-medium transition-colors hover:no-underline">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              </motion.div>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
